// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1Uvdc","infoBtn":"quickbooks_infoBtn__2XjG8","formBox":"quickbooks_formBox__1Ohgq","formFooter":"quickbooks_formFooter__3PVQq"};